import { useApiQuery } from 'theSource/utils/useApiQuery';
import { getCompanyName } from 'theSource/utils/utils';
import { CompanySettingsResponseDto } from './types';
import { GET_COMPANY_SETTINGS_QUERY_KEY } from './utils';

interface UseCompanySettingsQueryProps {
  enabled: boolean;
}

export const useCompanySettingsQuery = ({
  enabled,
}: UseCompanySettingsQueryProps) => {
  const companyName = getCompanyName();

  const { data: companySettings, isLoading } = useApiQuery<
    CompanySettingsResponseDto,
    unknown
  >({
    queryKey: GET_COMPANY_SETTINGS_QUERY_KEY,
    endpoint: `/pwa/${companyName}/settings`,
    showErrorSnackbar: false,
    onError: (res) => {
      if (res.response?.status === 404) {
        // 404 is returned when no org name does not map to URL
        window.location.replace('/'); // will show 404 page if org name doesn't exist
      }
    },
    enabled: Boolean(enabled && companyName),
  });
  return { companySettings, isLoading };
};
